import { IGetModuleResponseBody, IModule } from './IGetModules';
import { IGetMenusByUserResponseBody } from './IGetMenusByUser';
import { IMasterMenuProps } from '@core-web/ui';

export enum EventTypes {
  GET_MENUS = 'GET_MENUS',
  GET_MODULES = 'GET_MODULES',
  SET_ACTIVE_MODULE_MASTER_MENU = 'SET_ACTIVE_MODULE_MASTER_MENU',
  SET_ACTIVE_PAGE = 'SET_ACTIVE_PAGE',
  SET_ACTIVE_MODULE = 'SET_ACTIVE_MODULE',
  SET_ACTIVE_MASTER_MENU = 'SET_ACTIVE_MASTER_MENU',
}

export interface IActivePage {
  activePage: string;
}

export interface IActiveModuleMasterMenu {
  module: IModule;
  masterMenu: IMasterMenuProps;
}

/**
 * The navigation reducer
 */

export interface INavigationReducer {
  activePage: string;
  modules: IGetModuleResponseBody;
  drawerMenus: IGetMenusByUserResponseBody;
  activeModule: IModule | null;
  activeMasterMenu: IMasterMenuProps | null;
}

export type IReducerPayload =
  | IActivePage
  | IGetModuleResponseBody
  | IGetMenusByUserResponseBody
  | IModule
  | IMasterMenuProps
  | IActiveModuleMasterMenu
  | null;
